import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  return (
    <div style={{background: '#ffffff'}}>
      <Helmet>
        <title>RMQ Digital - Business Communication Solutions | A2P Compliant</title>
        <meta name="description" content="Professional customer communication platform offering secure notifications, alerts, and customer engagement tools. TCPA and A2P 10DLC compliant services." />
        <meta name="keywords" content="customer notifications, business communications, transactional messaging, customer alerts, A2P 10DLC, TCPA compliant" />
      </Helmet>

      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, #6d28d9 0%, #8b5cf6 50%, #a78bfa 100%)',
        padding: '8rem 2rem 6rem',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, opacity: 0.1}}>
          <div style={{position: 'absolute', top: '10%', left: '10%', width: '300px', height: '300px', background: '#fff', borderRadius: '50%', filter: 'blur(100px)'}}></div>
          <div style={{position: 'absolute', bottom: '10%', right: '10%', width: '400px', height: '400px', background: '#f59e0b', borderRadius: '50%', filter: 'blur(120px)'}}></div>
        </div>
        
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{textAlign: 'center', maxWidth: '800px', margin: '0 auto'}}>
            <div style={{display: 'inline-flex', alignItems: 'center', gap: '0.5rem', padding: '0.5rem 1rem', background: 'rgba(255,255,255,0.2)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '50px', marginBottom: '2rem', fontSize: '0.875rem', color: '#fff'}}>
              <span style={{width: '8px', height: '8px', background: '#f59e0b', borderRadius: '50%'}}></span>
              A2P 10DLC Registered & TCPA Compliant
            </div>
            
            <h1 style={{fontSize: '4rem', fontWeight: '800', lineHeight: '1.1', marginBottom: '1.5rem', color: '#ffffff', fontFamily: 'Space Grotesk'}}>
              Smart Customer Communication
              <br />
              <span style={{color: '#f59e0b'}}>For Modern Businesses</span>
            </h1>
            
            <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.9)', marginBottom: '2.5rem', lineHeight: '1.8'}}>
              Secure and compliant customer communication platform. Send notifications, alerts, and service updates with confidence.
            </p>
            
            <div style={{display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap'}}>
              <Link to="/contact" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '1rem 2rem',
                background: '#f59e0b',
                color: '#1f2937',
                textDecoration: 'none',
                borderRadius: '12px',
                fontWeight: '700',
                fontSize: '1.1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 8px 24px rgba(245, 158, 11, 0.4)'
              }}>
                Get Started Free
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </Link>
              
              <Link to="/pricing" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                padding: '1rem 2rem',
                background: 'rgba(255,255,255,0.2)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '12px',
                fontWeight: '700',
                fontSize: '1.1rem',
                border: '2px solid rgba(255,255,255,0.3)',
                transition: 'all 0.3s ease'
              }}>
                View Pricing
              </Link>
            </div>
            
            {/* Stats */}
            <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2rem', marginTop: '4rem', paddingTop: '2rem', borderTop: '1px solid rgba(255,255,255,0.2)'}}>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#f59e0b', marginBottom: '0.25rem'}}>99.9%</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>Delivery Rate</div>
              </div>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#f59e0b', marginBottom: '0.25rem'}}>24/7</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>Support</div>
              </div>
              <div>
                <div style={{fontSize: '2.5rem', fontWeight: '800', color: '#f59e0b', marginBottom: '0.25rem'}}>100%</div>
                <div style={{fontSize: '0.875rem', color: 'rgba(255,255,255,0.8)'}}>TCPA Compliant</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section style={{padding: '6rem 2rem', background: '#f9fafb'}}>
        <div style={{maxWidth: '1200px', margin: '0 auto'}}>
          {/* Hero Image */}
          <div style={{marginBottom: '4rem', borderRadius: '16px', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.1)'}}>
            <img 
              src="https://images.unsplash.com/photo-1553877522-43269d4ea984?w=1200&h=400&fit=crop" 
              alt="Business team collaboration" 
              style={{width: '100%', height: '400px', objectFit: 'cover'}}
            />
          </div>
          
          <div style={{textAlign: 'center', marginBottom: '4rem'}}>
            <div style={{display: 'inline-block', padding: '0.5rem 1rem', background: '#ede9fe', color: '#6d28d9', borderRadius: '50px', fontSize: '0.875rem', fontWeight: '600', marginBottom: '1rem'}}>
              Our Services
            </div>
            <h2 style={{fontSize: '3rem', fontWeight: '800', marginBottom: '1rem', fontFamily: 'Space Grotesk'}}>
              Complete Communication <span style={{color: '#6d28d9'}}>Solutions</span>
            </h2>
            <p style={{fontSize: '1.25rem', color: '#6b7280', maxWidth: '600px', margin: '0 auto'}}>
              Everything you need to communicate with your customers effectively
            </p>
          </div>

          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem'}}>
            {[
              {icon: '📱', title: 'Customer Notifications', desc: 'A2P 10DLC compliant appointment reminders and service alerts with high delivery rates', color: '#6d28d9', link: '/services'},
              {icon: '✉️', title: 'Email Communications', desc: 'Transactional emails and account notifications with automation', color: '#8b5cf6', link: '/services'},
              {icon: '🚀', title: 'Communication Management', desc: 'Streamlined customer communication workflows with compliance monitoring', color: '#a78bfa', link: '/services'},
              {icon: '⚡', title: 'Workflow Automation', desc: 'Automated customer service messages and account updates', color: '#ddd6fe', link: '/services'},
              {icon: '📊', title: 'Analytics & Reporting', desc: 'Detailed insights and delivery metrics for all communications', color: '#c4b5fd', link: '/services'},
              {icon: '🎯', title: 'API Integration', desc: 'Seamless integration with your existing CRM and business systems', color: '#ede9fe', link: '/services'}
            ].map((service, index) => (
              <Link 
                key={index} 
                to={service.link}
                style={{
                  background: 'white',
                  padding: '2.5rem',
                  borderRadius: '16px',
                  border: '1px solid #e5e7eb',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  display: 'block'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 12px 32px rgba(109, 40, 217, 0.15)';
                  e.currentTarget.style.borderColor = service.color;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                  e.currentTarget.style.borderColor = '#e5e7eb';
                }}
              >
                <div style={{fontSize: '3rem', marginBottom: '1rem'}}>{service.icon}</div>
                <h3 style={{fontSize: '1.5rem', fontWeight: '700', marginBottom: '0.75rem', color: '#1f2937'}}>{service.title}</h3>
                <p style={{color: '#6b7280', lineHeight: '1.6'}}>{service.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{padding: '6rem 2rem', background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)', position: 'relative', overflow: 'hidden'}}>
        <div style={{position: 'absolute', top: '0', right: '0', width: '500px', height: '500px', background: 'radial-gradient(circle, rgba(109, 40, 217, 0.2) 0%, transparent 70%)', borderRadius: '50%'}}></div>
        <div style={{maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1}}>
          <div style={{maxWidth: '800px', margin: '0 auto', textAlign: 'center'}}>
            <h2 style={{fontSize: '3rem', fontWeight: '800', color: 'white', marginBottom: '1.5rem', fontFamily: 'Space Grotesk'}}>
              Ready to Improve Customer Communication?
            </h2>
            <p style={{fontSize: '1.25rem', color: 'rgba(255,255,255,0.8)', marginBottom: '3rem', lineHeight: '1.8'}}>
              Join hundreds of businesses using our platform for secure and compliant customer communications
            </p>
            <Link to="/contact" style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.75rem',
              padding: '1.25rem 3rem',
              background: '#f59e0b',
              color: '#1f2937',
              textDecoration: 'none',
              borderRadius: '12px',
              fontWeight: '700',
              fontSize: '1.25rem',
              boxShadow: '0 8px 32px rgba(245, 158, 11, 0.4)',
              transition: 'all 0.3s ease'
            }}>
              Get Started Today
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
